import React from "react";
const SwiperRight = () => (
  <svg width="16" height="28" viewBox="0 0 16 28" xmlns="http://www.w3.org/2000/svg">
    <path  d="M-0.000297331 24.851L2.4612 27.3125L15.9994 13.7743L15.8814 13.6562L16 13.5377L2.46176 -0.000560037L0.000263479 2.46094L11.195 13.6557L-0.000297331 24.851Z" fill="white"/>
  </svg>
);
export default SwiperRight;
